/*
DoubleIncCardsPC.js
双增公式的PC版的卡片页面
 */

import React, {useEffect, useState} from "react";
import {Row, Col, Space} from "antd";
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    useDndMonitor
} from "@dnd-kit/core";
import {arrayMove, SortableContext, sortableKeyboardCoordinates, rectSortingStrategy} from "@dnd-kit/sortable";

import "../DoubleIncCardsStyle.css"
import DoubleIncCard from "../DoubleIncCard/DoubleIncCard";
import {SortableItem} from "../DoubleIncCard/SortableItem";
import DoubleIncCardEditingDrawer from "../DoubleIncCard/DoubleIncCardEditingDrawer";
import {getAllCards, updateCardsIndex} from "../../../Model/DoubleIncIndexedDB/DoubleIncIndexedDB";


const DoubleIncCardsView = ({isMobile}) => {
    const [cards, setCards] = useState([]);
    // 编辑Drawer是否开启
    const [isEditingDrawerOpen, setIsEditingDrawerOpen] = useState(false);
    const [drawerCardID, setDrawerCardID] = useState(-1);

    // 初始化传感器（支持鼠标和键盘拖拽）
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8, // 拖拽触发的最小距离，避免误触
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    // 载入时重载卡片
    useEffect(() => {
        handleRefreshCards();
    }, []);

    // 刷新数据
    const handleRefreshCards = () => {
        getAllCards().then((cards) => {
            setCards(cards);
        })
    };

    // 处理拖拽结束事件
    const handleDragEnd = (event) => {
        const {active, over} = event;

        if (active.id !== over.id) {
            setCards((card) => {
                // 找到原始卡片的旧位置和新位置
                const oldIndex = cards.findIndex((card) => card.id === active.id);
                const newIndex = cards.findIndex((card) => card.id === over.id);
                // 使用 arrayMove 来重新排序
                const updatedItems = arrayMove(cards, oldIndex, newIndex);
                // 更新每个卡片的 index 字段
                const updatedItemsWithIndex = updatedItems.map((card, index) => {
                    // 返回更新后的卡片对象，给每个卡片分配新的 index
                    return {...card, index};
                });
                updateCardsIndex(updatedItemsWithIndex).then();
                return updatedItemsWithIndex;
            });
        }
    };

    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            {/*移动端页面*/}
            {isMobile &&
                <SortableContext items={cards} strategy={rectSortingStrategy}>
                    <Space size='large' direction='vertical' style={{width: '80%'}}>
                        {cards.map((card) => (
                            <SortableItem key={card.id} id={card.id} disableDrag={isEditingDrawerOpen}>
                                <DoubleIncCard key={card.id} id={card.id}
                                               setIsEditingDrawerOpen={setIsEditingDrawerOpen}
                                               setDrawerCardID={setDrawerCardID} card={card}
                                               handleRefreshCards={handleRefreshCards}/>
                            </SortableItem>
                        ))}
                    </Space>
                </SortableContext>}
            {/*PC端*/}
            {!isMobile &&
                <Row justify='space-between' style={{width: '90%', marginTop: 50}}>
                    <Col span={11}>
                        <SortableContext items={cards} strategy={rectSortingStrategy}>
                            <Space size='large' direction='vertical' style={{width: '100%'}}>
                                {cards.slice(0, 2).map((card) => (
                                    <SortableItem key={card.id} id={card.id} disableDrag={isEditingDrawerOpen}>
                                        <DoubleIncCard key={card.id} id={card.id}
                                                       setIsEditingDrawerOpen={setIsEditingDrawerOpen}
                                                       setDrawerCardID={setDrawerCardID} card={card}
                                                       handleRefreshCards={handleRefreshCards}/>
                                    </SortableItem>
                                ))}
                            </Space>
                        </SortableContext>
                    </Col>
                    <Col span={11}>
                        <SortableContext items={cards} strategy={rectSortingStrategy}>
                            <Space size='large' direction='vertical' style={{width: '100%'}}>
                                {cards.slice(2, 4).map((card) => (
                                    <SortableItem key={card.id} id={card.id} disableDrag={isEditingDrawerOpen}>
                                        <DoubleIncCard key={card.id} id={card.id}
                                                       setIsEditingDrawerOpen={setIsEditingDrawerOpen}
                                                       setDrawerCardID={setDrawerCardID} card={card}
                                                       handleRefreshCards={handleRefreshCards}/>
                                    </SortableItem>
                                ))}
                            </Space>
                        </SortableContext>
                    </Col>
                </Row>
            }
            <DoubleIncCardEditingDrawer isMobile={isMobile} open={isEditingDrawerOpen} setOpen={setIsEditingDrawerOpen}
                                        drawerCardID={drawerCardID} handleRefreshCards={handleRefreshCards}/>
        </DndContext>
    );
};

export default DoubleIncCardsView;